import * as yup from 'yup';

export const useCaptchaTokenValidation = () => {
  return {
    token: yup.string().optional(),
  };
};
